export const Lado1 = '1'
export const Lado2 = '2'